import createCachedSelector from "re-reselect";

const emptyObject = {};
const defaultKnockoutCriteria = {
  isLoaded: false
};

export const getPartnerKnockoutCriteria = (state, partnerId) => {
  const partnerKnockoutCriteria = state.entities.offerPartnerKnockoutCriteria[partnerId];
  return partnerKnockoutCriteria ? partnerKnockoutCriteria.knockoutCriteria : emptyObject;
};
const getKnockoutCriteria = (state, partnerId) =>
  state.currentOffer.partnerKnockoutCriteria.knockoutCriteria[partnerId] || defaultKnockoutCriteria;

export const getKnockoutCriteriaIsLoaded = createCachedSelector(getKnockoutCriteria, knockoutCriteria => {
  return knockoutCriteria.isLoaded;
})((_, partnerId) => partnerId);

export const getOfferPartnerKnockoutCriteria = createCachedSelector(
  getKnockoutCriteriaIsLoaded,
  getPartnerKnockoutCriteria,
  (isLoaded, knockoutCriteria) => {
    if (!isLoaded) {
      return emptyObject;
    }
    return knockoutCriteria;
  }
)((_, partnerId) => partnerId);
